<template>
  <div class="company">
    <h1>关于{{detailList.simple_name}}拍卖行</h1>
    <div class="regards">
      <div class="main">
        <strong>
          公司名称：  {{ detailList.organ_name }}
        </strong>
      </div>
      <div class="main">
        <strong>
          信用认证：  {{ detailList.IsStandard == 1 ? '拍卖标准化达标企业' : ''  }}{{ detailList.IsZhongpai == 1 ? '中拍协自律公约成员单位' : '' }}
        </strong>
      </div>
      <div class="main" v-if="detailList.core_business !== '0' && detailList.core_business !== ''">
        <strong>
          核心业务：  {{ detailList.core_business }}
        </strong>
      </div>
      <div class="main">
        <strong>
          所属地区：  {{ detailList.area }}
        </strong>
      </div>
    </div>
    <div class="introduce" v-html="detailList.discript">
    </div>
    <div class="imageRes" v-if="detailList.OrganMapPic">
      <img :src="detailList.OrganMapPic.replace('s_', '')">
    </div>
  </div>
</template>

<script>
// 调用接口
import { postDetail } from '@/api/company'
export default {
  name: 'company',
  data() {
    return {
      detailList: []
    }
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    postDetail(name) {
      postDetail({
        web_name: name
      }).then(res => {
        console.log('专区详情', res.data);
        this.detailList = res.data
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>